const locales = {
  DEFAULT_LOCALE: 'ru',
  SUPPORTED_LOCALES: ['ky', 'ru'],
};

module.exports = locales;
